import React, { Component } from 'react';
import './MessagesText.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TabDataDistributor from '../../Containers/TabDataDistributor';
import { updateCurrentTabStatus } from '../../Redux/Actions/uiActions';
import { bindActionCreators } from 'redux';

import MSGTEXTBLACKICON from '../../../assets/icons/sideNavIcons/ic_messageTextBlack.png';
class MessagesText extends Component {

    componentDidMount() {
        this.selectedTab = this.props.location.pathname.split('/')[2];
        let tempArray = this.props.tabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g, '').replace(/\//g, '') === this.selectedTab;
        });
        if (tempArray.length) {
            this.props.updateCurrentTabStatus(this.selectedTab);
        } else if (this.selectedTab === 'settings') {
            this.props.updateCurrentTabStatus(this.selectedTab);
        }
        else {
            alert('This is not a valid tab');
        }
    }

    render() {
        return (
            <>
                <div className='tab-title-wrapper'>
                    <div className='tab-title-icon-wrapper'>
                        <img src={MSGTEXTBLACKICON} name='MiscText' width='24px' height='24px' alt='Misc Text' />
                    </div>
                    <span className='tab-title-text' title='Misc Text'>Message Text</span>
                </div>
                <div className='tab-pane fade active in show'>
                    <TabDataDistributor
                        tempdata={this.props.editableBotData.UI_OPTIONS ? { data: this.props.editableBotData.UI_OPTIONS.MISC_TEXT, title: 'MISC_TEXT', parentArray: ['MISC_TEXT'], isGeneric: false } : {}}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        selectedBot: state.UiReducer && state.UiReducer.selectedBot && (state.UiReducer.selectedBot !== 'Select Bot') ? state.UiReducer.selectedBot : false,
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : []
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessagesText));
